// extracted by mini-css-extract-plugin
export var formContainer = "_hd-0";
export var message = "_hd-1";